<template>
  <div :id="id" :echartTitle="echartTitle" style="height: 100%"></div>
</template>

<script>

import EmCommonApi from "@/mixin/em/common/api";
import * as echarts from 'echarts';

export default {
  name: "echartLeft_1",
  mixins: [EmCommonApi],
  props: {
    id: String,
    echartTitle: String,
  },
  data() {
    return {
      chart: {},
      option: {},
      fresh: {},
      speed: 0,
    }
  },
  watch:{

  },
  created() {
    this.getRemoteData()
  },
  mounted() {
    this.loadChart()  //测试，后端取数这里屏蔽

    //定时轮巡查询
    this.fresh = setInterval(() => {
      this.getRemoteData();
      window.addEventListener('resize', this.chart.resize, false)
    },  5000);

  },
  beforeDestroy() {
    clearInterval(this.fresh);
    //window.removeEventListener('resize', this.chart.resize, false)
  },
  methods: {
    getRemoteData() {
      const _api = this.$_emApiMixin_entityBaseApi("emSicEafmREocEmrec") + "/getOneByModuleCode?" +
          "code=1-2-2"
      // console.log("speed url：")
      // console.log(_api)
      this.$_emApiMixin_get(_api)
          .then((res) => {
            // console.log("提取北车速度值：")
            // console.log(res)

            if(res.newValue.value != null){
              this.speed = parseFloat(res.newValue.value).toFixed(2)
            }
            else{
              this.speed = 0.0
            }

            this.loadChart();  //异步渲染echarts
          })



    },
    loadChart(){
      this.option = {
        title: {
          text: this.echartTitle,
          textStyle:{
            //文字颜色
            color:'white',
            //字体风格,'normal','italic','oblique'
            fontStyle:'normal',
            //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            fontWeight:'normal',
            //字体系列
            fontFamily:'微软雅黑',
            //字体大小
            fontSize:18,
          }
        },
        // xAxis: {},
        // yAxis: {},
        series: [{
          startAngle: 210, //开始角度 左侧角度
          endAngle: -30, //结束角度 右侧

          name: '速度',
          type: 'gauge',
          min: 0,   //不填默认0-100
          max: 50,
          title : {               //【设置仪表盘中间显示文字样式】
            offsetCenter: [1,"-50%"], //仪表盘标题文字位置
            textStyle: {       // 其余性默认使用全局文本样式，详见TEXTSTYLE
              fontWeight: 'bolder',
              fontSize: 12,
              fontStyle: 'italic',
              color:"white"
            }
          },
          // detail: {
          //   //设置仪表盘下方显示内容的位置
          //   offsetCenter: [1,"40%"],  //仪表盘下方文字位置
          //   formatter:'{value}m/s',   //表针下值的样式
          //   textStyle:{color:'white',fontSize:16},
          // },
          detail: {
            //方框样式
            backgroundColor: '#fff',
            borderColor: '#999',
            borderWidth: 2,
            width: '65%',
            lineHeight: 22,
            height: 22,
            borderRadius: 8,
            offsetCenter: [0, '60%'],
            valueAnimation: true,
            formatter: function (value) {
              return '{value|' + value + '}{unit|r/m}';    //value.toFixed(0)
            },
            rich: {
              value: {
                fontSize: 18,
                fontWeight: 'bolder',
                color: '#333'
              },
              unit: {
                fontSize: 16,
                color: '#999',
                padding: [0, 0, -20, 10]
              }
            }
          },
          data: [{
            value:this.speed,
            name: "电机转速",
          }],
          center: ["50%", "50%"], // 默认全局居中
          splitLine : {
            //分割线样式（及10、20等长线样式）  指针刻度
            // length : 18,
            // lineStyle: {            // 分隔线样式。
            //   color: "#eee",              //线的颜色,默认 #eee。
            //   opacity: 1,                 //图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形。
            //   width: 1,                   //线度,默认 2。
            //   type: "solid",              //线的类型,默认 solid。 此外还有 dashed,dotted
            //   shadowBlur: 5,             //(发光效果)图形阴影的模糊大小。该属性配合 shadowColor,shadowOffsetX, shadowOffsetY 一起设置图形的阴影效果。
            //   shadowColor: "#fff",        //阴影颜色。支持的格式同color。
            // }
            distance: -9,
            length: 10,
            lineStyle: {
              color: '#fff',
              width: 4
            }
          },
          axisLabel : {
            //文字样式（及“10”、“20”等文字样式）   //【刻度数字】样式
            distance : 15,   //文字离表盘的距离
            color: 'auto',  //white  auto：文字颜色随外框颜色变化
            //fontSize: 20
          },
          pointer: {
            //【指针样式】
            //length: '10%',
            itemStyle: {
              color: 'auto', //颜色随外框变化
            }
          },
          axisLine: {
            //【仪表盘的环】样式
            show : true,// 是否显示仪表盘轴线(轮廓外框),默认 true。
            lineStyle: {
              //     shadowBlur: 2,             //(发光效果)图形阴影的模糊大小。该属性配合 shadowColor,shadowOffsetX, shadowOffsetY 一起设置图形的阴影效果。
              //     shadowColor: "#fff",        //阴影颜色。支持的格式同color。
              width: 10,  //表盘颜色外框宽度
              color: [
                [0.7, '#67e0e3'],
                // [0.7, '#37a2da'],
                [1, '#fd666d']
              ],
            }
          },

        }]
      }
      this.chart = echarts.init(document.getElementById(this.id));
      this.chart.setOption(this.option)

      //echart浏览器自动缩放
      // let myChart = this.chart;
      /// window.addEventListener('resize',()=>{
      //   myChart.resize();
      // })
    }
  }
}
</script>

<style scoped>

</style>
